export default "__VITE_ASSET__DnDOWfoN__"